<template>
  <div class="animated fadeIn" v-if="$auth.check(['UFS', 'SUPER'])">
    Dashboard do Inpar
  </div>
</template>

<script>
export default {
  name: 'dashboard',
  components: {}
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }.main .container-fluid {
  padding: 50px 30px !important;
}
</style>
